import RandomMove from "./RandomMove.js";

export default class MoveTo extends RandomMove {
	constructor(initer) {
		super(initer);
		this.endCell = initer.endCell
		this.dir = null;
		this.traveled = 0;
		this.destroyed = false;
	}

	init(payload = null) {
		this.startCell = this.mob.cell;
		/*console.log("--------------")
		console.log(this.startCell.tiles[0], this.endCell.tiles[0])*/

		if (this.endCell.row < this.startCell.row) {
			this.dir = RandomMove.DIR_N;
		} else if (this.endCell.row > this.startCell.row) {
			this.dir = RandomMove.DIR_S;
		} else if (this.endCell.col < this.startCell.col) {
			this.dir = RandomMove.DIR_W;
		} else if (this.endCell.col > this.startCell.col) {
			this.dir = RandomMove.DIR_E;
		}

		//this.checking();
		this.inProgress(this);
	}


	trackDone(lEsit) {
		/*console.log(this.startCell.tiles[0], this.endCell.tiles[0])
		console.log(lEsit)
		console.log(this.mob.ai.heroTargetted)*/
		this.accomplished({ data: this.dir, reached: lEsit });
	}


}